import NiceAvatar from "app/components/NiceAvatar";
import { IAvatar } from "app/containers/Features/containers/TeamSettings/container/MySetting/types";
import clsx from "clsx";
import React from "react";
import { getInitials } from "utils/helpers";
import LazyImage from "app/components/LazyImage";

interface Props {
  name: string;
  avatar: IAvatar | undefined;
  className?: string;
  circleClassName?: string;
  statusClassName?: string;
  initialsClassName?: string;
  hideStatus?: boolean;
}
const ProfileAvatar: React.FC<Props> = ({
  name,
  avatar,
  circleClassName,
  className,
  statusClassName,
  initialsClassName,
  hideStatus = false,
}) => {
  return (
    <button className={clsx("flex flex-row items-center relative", className)}>
      <div
        className={clsx(
          " size-[30px] flex items-center justify-center rounded-full",
          circleClassName
        )}
      >
        {avatar?.file ? (
          <LazyImage
            src={avatar?.file}
            alt={name}
            wrapperClassName="w-full"
            circle
          />
        ) : avatar?.icon ? (
          <NiceAvatar seed={avatar?.icon} shape="circle" />
        ) : (
          <span
            style={{
              backgroundColor:
                avatar?.color && avatar.color.length > 0
                  ? avatar.color
                  : "#8CCDEC",
            }}
            className={clsx("text-xs text-white font-normal size-full rounded-full items-center justify-center flex ",initialsClassName)}
          >
            {getInitials(name)}
          </span>
        )}
      </div>
      {!hideStatus && (
        <div
          className={`size-[5px] bg-green rounded-full absolute bottom-0 right-0 ${statusClassName}`}
        />
      )}
    </button>
  );
};

export default ProfileAvatar;
